import AudiencePage from "../components/AudiencePage";

const AUDIENCES = {
  "truman-lake-fishing": {
    eyebrow: "Truman Lake Anglers & Boaters",
    breadcrumbLabel: "Truman Lake Fishing",
    title: "Hotels near Truman Lake: boat parking, boat charging, and hot breakfast at 5 AM.",
    intro: "Sparrowfoot in 15 minutes. Bucksaw in 25. Long Shoal Marina in 40. Westbridge is the base tournament anglers and weekend crappie fishermen keep coming back to.",
    image: "/images/attractions/truman-dam.jpg",
    metaTitle: "Hotels Near Truman Lake — Boat Parking & Charging",
    metaDesc: "The closest full-service hotel to Sparrowfoot, Bucksaw and Long Shoal Marina on Truman Lake — with boat & trailer parking and boat charging access for anglers. Great service. Clean rooms.",
    whyTitle: "Built for Truman Lake fishermen.",
    whyLead: "You need truck-and-trailer parking, boat charging overnight, and a breakfast that starts before the ramp does. That's why we exist.",
    whyBullets: [
      { title: "Boat & trailer parking", body: "Dedicated space. Pull the whole rig in without jockeying." },
      { title: "Boat charging access", body: "Lithium banks, trolling motor batteries — ask the desk on arrival for the outlets." },
      { title: "Hot breakfast opens early", body: "Coffee before the ramp opens. Real hot food, free, every morning." },
      { title: "24-hour front desk", body: "Phone rings straight to a real person, at any hour." },
      { title: "Truck parking", body: "Room for full-size pickups and heavy-duty rigs." },
      { title: "Tournament group blocks", body: "Call the desk with your field size — we'll set up a code and hold inventory." },
    ],
    amenityHighlights: [
      "Sparrowfoot 4-lane ramp — 15 min south",
      "Bucksaw Marina — 25 min southeast",
      "Long Shoal Marina — 40 min via Warsaw",
      "Trucker rate available (ask the desk)",
      "Free deluxe hot breakfast",
      "Free WiFi & parking",
      "Fridge in every room",
      "Renovated rooms with Euro-top mattresses",
      "Group blocks by phone for tournaments",
    ],
    roomSlugs: ["queen-double", "three-bedroom-family-suite", "king-suite"],
    faqCategory: "Truman Lake & Fishing",
    faqTitle: "Truman Lake angler questions.",
    faqLimit: 6,
    blogSlugs: [
      "hotels-near-truman-lake-clinton-mo",
      "crappie-fishing-tournaments-truman-lake",
      "truman-lake-boat-ramps-marinas",
    ],
  },

  "katy-trail-cyclists": {
    eyebrow: "Katy Trail Cyclists",
    breadcrumbLabel: "Katy Trail Cyclists",
    title: "Katy Trail lodging: the western terminus is 2 miles from our front desk.",
    intro: "Clinton is the western end of the 240-mile Katy Trail State Park. The trailhead is on N Price Lane off Highway 52. We're the closest full-service hotel with real showers, bike-friendly rooms, and a hot breakfast that opens early.",
    image: "/images/attractions/katy-trail.jpg",
    metaTitle: "Katy Trail Lodging in Clinton MO — Western Terminus",
    metaDesc: "Katy Trail State Park lodging in Clinton, MO — 2 miles from the western terminus trailhead. Bike-friendly rooms, real showers, hot breakfast and 24-hour front desk.",
    whyTitle: "Built for cyclists starting or ending 240 miles.",
    whyLead: "Whether you're rolling east from Clinton or arriving from Machens, this is the recovery bed you actually want at the end of the ride.",
    whyBullets: [
      { title: "2 miles from the trailhead", body: "N Price Lane off Highway 52, 0.1 miles west of the 7/13 intersection." },
      { title: "Bikes welcome in rooms", body: "A $4,000 bike shouldn't sleep in the parking lot." },
      { title: "Real showers", body: "LED-lit granite baths and real hot water — not a locker-room afterthought." },
      { title: "Early hot breakfast", body: "Free, hot, and open in time for a sensible first pedal." },
      { title: "Laundry (call ahead)", body: "Availability varies — tell us when you book so we can plan." },
      { title: "Rock Island Trail junction 19 miles away", body: "Windsor is the junction of the Katy and Rock Island trails." },
    ],
    amenityHighlights: [
      "Clinton Trailhead — 2 mi / 6 min",
      "Rock Island Trail junction (Windsor) — 19 mi / 29 min",
      "Free hot breakfast, early hours",
      "LED-lit granite baths",
      "Euro-top mattresses in King and Jacuzzi suites",
      "Free WiFi & parking",
      "24-hour front desk",
      "Renovated rooms",
      "Bike-friendly policy",
    ],
    roomSlugs: ["king-suite", "standard-queen", "jacuzzi-suite"],
    faqCategory: "Katy Trail",
    faqTitle: "Katy Trail cyclist questions.",
    faqLimit: 5,
    blogSlugs: [
      "katy-trail-western-terminus-clinton",
      "windsor-mo-lodging",
      "clinton-square-restaurants-shops",
    ],
  },

  "pet-friendly": {
    eyebrow: "Pet Travelers",
    breadcrumbLabel: "Pet Friendly Hotel",
    title: "Pet friendly hotel in Clinton MO: two pets per room, green space to walk.",
    intro: "Up to two pets welcome per room. Small pet fee — call for current amounts. Artesian Park is a short drive for a proper leash-legs. And the front desk gets a lot of dog visits.",
    image: "/images/exterior-7.jpg",
    metaTitle: "Pet Friendly Hotel Clinton MO — 2 Pets/Room",
    metaDesc: "Pet friendly hotel in Clinton, Missouri — up to two pets per room. Green space on-site, Artesian Park nearby, and a 24-hour front desk that likes dogs.",
    whyTitle: "Bring the dog. Actually bring the dog.",
    whyLead: "Pet friendly isn't a footnote here — it's a real policy with real rules that keep everyone happy.",
    whyBullets: [
      { title: "2 pets per room", body: "Well-behaved dogs and cats. Ask the desk about size on your call." },
      { title: "Small pet fee", body: "Call (660) 885-2206 for the current amount so nothing surprises you at check-in." },
      { title: "Green space to walk", body: "On property and at Artesian Park, a short drive away." },
      { title: "Ground-floor options", body: "Ask for an easy in-and-out for the dog when you book." },
      { title: "Water bowls at the desk", body: "On request. We keep a stack." },
      { title: "Clear rules", body: "Leashed on property, not left unattended in rooms. Simple." },
    ],
    amenityHighlights: [
      "2 pets per room max",
      "Small pet fee (call for amount)",
      "Ground-floor rooms available",
      "Green space on-site",
      "Artesian Park — short drive",
      "Free hot breakfast for you",
      "Renovated rooms",
      "Free parking including trailer space",
      "24-hour front desk",
    ],
    roomSlugs: ["standard-queen", "king-suite", "queen-double"],
    faqCategory: "Pets",
    faqTitle: "Pet friendly questions.",
    faqLimit: 6,
    blogSlugs: [
      "pet-friendly-road-trips-west-central-missouri",
      "clinton-square-restaurants-shops",
      "kansas-city-to-truman-lake-weekend",
    ],
  },

  "boaters": {
    eyebrow: "Boaters & Tournament Anglers",
    breadcrumbLabel: "Boaters",
    title: "Boat parking. Boat charging access. Real trailer room. Every Truman Lake ramp within 40 minutes.",
    intro: "Westbridge is the base tournament crews and weekend boaters keep coming back to. Purpose-built truck & trailer parking, overnight boat charging, and a hot breakfast that opens before the ramp does.",
    image: "/images/attractions/truman-dam.jpg",
    metaTitle: "Boater Hotel Clinton MO — Boat Parking & Charging Access",
    metaDesc: "Boater and tournament-angler hotel in Clinton, MO — dedicated boat & trailer parking, overnight boat charging access, and every Truman Lake ramp within 40 minutes.",
    whyTitle: "Built for boats. Built for boaters.",
    whyLead: "Trailer maneuvering room, real charging outlets, and the ramps you actually want to launch from within 15–40 minutes of the front desk.",
    whyBullets: [
      { title: "Boat & trailer parking", body: "Dedicated pull-through space with room to swing a 22-foot bass boat or an aluminum with a big kicker. Pull the whole rig in — leave it." },
      { title: "Boat charging access", body: "Lithium banks, trolling motor batteries, sonar packs — bring the charger, we've got the outlets. Ask the desk on arrival." },
      { title: "Trailer maneuvering room", body: "Not a squeeze between rental cars. Purpose-built for backing in and pulling out at 4:30 AM without waking the property." },
      { title: "Hot breakfast opens early", body: "Free deluxe hot breakfast is included every morning and opens in time for pre-dawn launches. Coffee. Real food. Free." },
      { title: "Tournament group blocks", body: "Call the desk with your field size and dates — we hold inventory under a code you can share to your competitors." },
      { title: "24-hour front desk", body: "If a trailer light dies at 3 AM or your co-angler cancels, the phone at (660) 885-2206 rings straight to a real person." },
    ],
    amenityHighlights: [
      "Dedicated boat & trailer parking",
      "BOAT CHARGING ACCESS (lithium & AGM)",
      "Truck parking for full-size rigs",
      "Free deluxe hot breakfast — early",
      "Tournament group blocks by phone",
      "24-hour front desk",
      "Free WiFi & parking",
      "Fridge in every room",
      "Renovated rooms with Euro-top mattresses",
    ],
    showTrumanRamps: true,
    roomSlugs: ["queen-double", "three-bedroom-family-suite", "king-suite"],
    faqCategory: "Parking",
    faqTitle: "Boater questions we hear on the phone.",
    faqLimit: 6,
    blogSlugs: [
      "hotels-near-truman-lake-clinton-mo",
      "truman-lake-boat-ramps-marinas",
      "crappie-fishing-tournaments-truman-lake",
    ],
  },

  "reunions": {
    eyebrow: "Festival & Reunion Guests",
    breadcrumbLabel: "Reunions & Festivals",
    title: "Family reunions & festival groups in Clinton MO.",
    intro: "Olde Glory Days, Henry County Fair week, class reunions, small weddings. Six room types, 32 rooms, group blocks by phone — we've been the reunion hotel for years.",
    image: "/images/exterior-3.jpg",
    metaTitle: "Family Reunion Hotel Clinton MO — Group Blocks",
    metaDesc: "Family reunion, wedding, and festival lodging in Clinton, MO — 32 rooms across six types, group blocks by phone, Family Suite sleeps six, Jacuzzi Suite for anniversary weekends.",
    whyTitle: "The reunion hotel for Clinton, Missouri.",
    whyLead: "Six room types under one roof means you can fit solo grandparents, cousin crews, and the family with three kids without splitting hotels.",
    whyBullets: [
      { title: "Group blocks by phone", body: "Call (660) 885-2206 and ask for a code. We hold inventory; family members book on their own cards." },
      { title: "Family Suite sleeps six", body: "Three full-size beds. Kids under 18 free in existing beds." },
      { title: "Jacuzzi Suite for anniversaries", body: "Because reunions and anniversaries often stack up." },
      { title: "Olde Glory Days ready", body: "0.6 miles from the historic downtown square where the festival happens." },
      { title: "Artesian Park nearby", body: "Reunion pavilion, pool, playgrounds — Clinton's reunion park." },
      { title: "Real breakfast for a crowd", body: "Free deluxe hot breakfast — nobody has to cook the morning-of." },
    ],
    amenityHighlights: [
      "32 rooms, 6 room types",
      "Family Suite (sleeps 6)",
      "Group blocks by phone",
      "Kids under 18 stay free",
      "Free hot breakfast",
      "Seasonal outdoor pool",
      "Historic square 0.6 mi away",
      "Artesian Park nearby",
      "Free parking",
    ],
    roomSlugs: ["three-bedroom-family-suite", "queen-double", "jacuzzi-suite"],
    faqCategory: "Events & Festivals",
    faqTitle: "Reunion & festival questions.",
    faqLimit: 6,
    blogSlugs: [
      "family-reunions-clinton-mo",
      "olde-glory-days-clinton-lodging",
      "clinton-square-restaurants-shops",
    ],
  },

  "extended-stay": {
    eyebrow: "Work Crews & Truckers",
    breadcrumbLabel: "Extended Stay & Truckers",
    title: "Extended-stay & trucker lodging in Clinton MO. Truck parking. Quiet halls.",
    intro: "Contractors, traveling nurses, utility crews, and truckers keep coming back. Dedicated truck & bus parking, our trucker rate, quiet halls, laundry (ask ahead), and a hot breakfast that starts before your shift.",
    image: "/images/exterior-4.jpg",
    metaTitle: "Extended Stay Hotel Clinton MO — Trucker Rate",
    metaDesc: "Extended-stay and trucker lodging at Westbridge Inn & Suites in Clinton, MO — dedicated truck & bus parking, trucker rate by phone, quiet halls, free hot breakfast.",
    whyTitle: "Built for the work stay.",
    whyLead: "Weekend rates on a work stay make no sense. Call and ask for our trucker or extended-stay rate.",
    whyBullets: [
      { title: "Dedicated truck & bus parking", body: "Purpose-built pull-through space." },
      { title: "Trucker rate by phone", body: "Call (660) 885-2206 and mention you're on a work run." },
      { title: "Extended-stay rates", body: "For multi-week jobs — priced for the whole run, not per night." },
      { title: "Quiet halls", body: "10 PM to 7 AM. If you're sleeping days, ask for a quiet-side room." },
      { title: "Laundry (call ahead)", body: "Availability varies — plan with the desk on booking." },
      { title: "Real hot breakfast", body: "So you're not eating a gas-station burrito at 4:45 AM." },
    ],
    amenityHighlights: [
      "Truck & bus parking",
      "Trucker rate (call)",
      "Extended-stay rate (call)",
      "Quiet halls 10 PM–7 AM",
      "Free hot breakfast",
      "Fridge in every room",
      "Microwave in Queen Double & Jacuzzi",
      "Free WiFi",
      "24-hour front desk",
    ],
    roomSlugs: ["standard-queen", "king-suite", "queen-double"],
    faqCategory: "Booking & Rates",
    faqTitle: "Work-stay questions.",
    faqLimit: 6,
    blogSlugs: [
      "work-crew-extended-stay-clinton-mo",
      "deer-season-lodging-henry-county",
      "hotels-near-truman-lake-clinton-mo",
    ],
  },

  "lake-activities": {
    eyebrow: "KC Weekenders",
    breadcrumbLabel: "Lake & Outdoor Activities",
    title: "Kansas City to Truman Lake: 1h 15m and you're at a real Missouri lake town.",
    intro: "MO-7 south. That's the whole route. Lake, Katy Trail, historic square, Henry County Museum, seasonal eagle watching in winter. Here's the outdoor recreation guide, verified.",
    image: "/images/exterior-2.jpg",
    metaTitle: "KC to Truman Lake Weekend — Clinton MO Hotel",
    metaDesc: "The perfect Kansas City to Truman Lake weekend base — Clinton, Missouri. Lake, Katy Trail, historic square, and winter eagle watching. 32 renovated rooms.",
    whyTitle: "The shortest legit lake weekend from KC.",
    whyLead: "1 hour 15 minutes on MO-7 south. No toll, no interstate stress. Real hotel, real dinner in town, real reasons to come back.",
    whyBullets: [
      { title: "Truman Lake (55,600 acres)", body: "Truman Dam in Warsaw is 38 min south; Sparrowfoot ramp is only 15 min from Westbridge." },
      { title: "Katy Trail western terminus", body: "2 miles from our front desk. Walk it or ride it." },
      { title: "Historic Downtown Square", body: "0.6 miles away. Real restaurants — Square 109, 303 Jefferson, Ben Franklin Bistro, The Branding Iron." },
      { title: "Winter eagle watching", body: "Bald eagles winter around Truman Dam tailwaters, late December through February." },
      { title: "Henry County Museum", body: "1886 Anheuser-Busch building, indoor 1900s village, open April–December." },
      { title: "Artesian Park", body: "50-meter outdoor pool, disc golf, amphitheater, and playgrounds." },
    ],
    amenityHighlights: [
      "1h 15min from Kansas City",
      "Sparrowfoot ramp — 15 min",
      "Truman Dam / Warsaw — 38 min",
      "Katy Trail terminus — 2 mi",
      "Historic Downtown Square — 0.6 mi",
      "Free deluxe hot breakfast",
      "Seasonal outdoor pool",
      "Free WiFi & parking",
      "Renovated rooms",
    ],
    roomSlugs: ["king-suite", "queen-double", "jacuzzi-suite"],
    faqCategory: "Location & Drive Times",
    faqTitle: "KC weekender questions.",
    faqLimit: 6,
    blogSlugs: [
      "kansas-city-to-truman-lake-weekend",
      "eagle-watching-truman-lake-winter",
      "warsaw-mo-truman-dam-guide",
    ],
  },
};

export default function AudienceLandingPage({ audienceKey }) {
  const config = AUDIENCES[audienceKey];
  if (!config) return null;
  return <AudiencePage config={config} />;
}
